module.exports = "<p>\r\n  bank-card-tile works!\r\n</p>\r\n"